
<div id="home"><app-home-slider ></app-home-slider></div>
<app-team ></app-team>
<section class="page-section" id="about">
    <div class="container">
        <div class="row">
        <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">About</h2>
            <h3 class="section-subheading text-muted">inspiring your growth</h3>
        </div>
        </div>
        <div class="row">
        <div class="col-lg-12">
            <ul class="timeline">
            <li>
                <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="assets/img/about/1.jpg" alt="">
                </div>
                <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4>Our Beginnings</h4>
                    <!-- <h4 class="subheading">Our Humble Beginnings</h4> -->
                </div>
                <div class="timeline-body">
                    <p class="text-muted">FS Personnel is a Generalist Recruitment Company
                        Established in 1997, based in Bloemfontein, Free State, South Africa</p>
                </div>
                </div>
            </li>
            <li class="timeline-inverted">
                <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="assets/img/about/2.jpg" alt="">
                </div>
                <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4>Our Specialties</h4>
                    <!-- <h4 class="subheading">An Agency is Born</h4> -->
                </div>
                <div class="timeline-body">
                    <p class="text-muted">We specialize in Staff Recruitment, both in Permanent-, Contract – and Temporary staff throughout South Africa across a spectrum of industry sectors (hopefully globally soon)</p>
                </div>
                </div>
            </li>
            <li>
                <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="assets/img/about/3.jpg" alt="">
                </div>
                <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4>honesty & integrity</h4>
                    <!-- <h4 class="subheading">Transition to Full Service</h4> -->
                </div>
                <div class="timeline-body">
                    <p class="text-muted">We endeavor to provide service excellence with old fashioned honesty and integrity as guidelines – to assist our clients in finding quality, dynamic people who fit the job-requirements and company culture</p>
                </div>
                </div>
            </li>
            <li class="timeline-inverted">
                <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="assets/img/about/4.jpg" alt="">
                </div>
                <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4>efficiency & effectiveness</h4>
                    <!-- <h4 class="subheading">Phase Two Expansion</h4> -->
                </div>
                <div class="timeline-body">
                    <p class="text-muted">We believe in speedy, efficient and effective service at all levels within your company</p>
                </div>
                </div>
            </li>
            <li>
                <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="assets/img/about/5.jpg" alt="">
                </div>
                <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4>Level 4 BEE</h4>
                    <!-- <h4 class="subheading">Transition to Full Service</h4> -->
                </div>
                <div class="timeline-body">
                    <p class="text-muted">With our Level 4 BEE status, FS Personnel values PEOPLE, be it the client or jobseeker</p>
                </div>
                </div>
            </li>
            <li class="timeline-inverted">
                <div class="timeline-image">
                <h4>Be Part
                    <br>Of Our
                    <br>Story!</h4>
                </div>
            </li>
            </ul>
        </div>
        </div>
    </div>
</section>